import { create } from 'zustand'

type SyncState = 'connected' | 'reconnecting' | 'offline'

interface ConnectionState {
  syncState: SyncState
  setSyncState: (state: SyncState) => void
}

export const useConnectionStore = create<ConnectionState>((set) => ({
  syncState: 'reconnecting',
  setSyncState: (syncState) => set({ syncState }),
}))
